class CultFooter extends HTMLElement {
  #media = window.matchMedia('(max-width: 749px)');
  #abortController = new AbortController();

  connectedCallback() {
    if (this.#abortController.signal.aborted) this.#abortController = new AbortController();
    this.#syncMenus();
    this.addEventListener('click', this.#handleClick, { signal: this.#abortController.signal });
    this.#media.addEventListener('change', this.#syncMenus, { signal: this.#abortController.signal });
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  #handleClick = (event) => {
    if (!this.#media.matches && event.target.closest('.cult-footer__menu > summary')) event.preventDefault();
  };

  #syncMenus = () => {
    this.querySelectorAll('.cult-footer__menu').forEach((menu) => {
      if (this.#media.matches) menu.removeAttribute('open');
      else menu.setAttribute('open', '');
    });
  };
}

if (!customElements.get('cult-footer')) customElements.define('cult-footer', CultFooter);
